<template>
    <div class="video_box">
        <video v-if="!isHack" ref="videoPlayer" class="video-js vjs-fluid" x5-playsinline="" playsinline="" webkit-playsinline=""></video>
        <div class="player-btn-hack" @click="hackPlayer" v-if="isHack || hack">无法播放，点击兼容播放</div>
        <div class="player-btn-hack player-btn-hack-v2" @click="copyUrl" v-if="isHack || hack">复制链接至手机浏览器播放</div>
    </div>
</template>

<script>
import videojs from 'video.js'
import zhCN from 'video.js/dist/lang/zh-CN.json'
import 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
import { updateSubjectItemLearned } from '../../pages/classroom/query.gql'

videojs.addLanguage('zh-CN', zhCN)

export default {
  name: 'VideoPlayer',
  props: {
    src: {
      type: Object,
      required: true
    },
    isHack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      player: null,
      hack: false
    }
  },
  watch: {
    src(val) {
      // 切换视频
      let source = [
        {
          src: val.video,
          type: 'application/x-mpegURL'
        }, {
          src: val.source,
          type: 'video/mp4'
        }
      ]

      this.player.src(source)
      this.player.poster(val.coverImage)
    }
  },
  mounted() {
    const self = this
    let ua = window.navigator.userAgent
    let version = ua.match(/os\s+(\d+)/i)
    if (version) {
      let iOSVer = parseInt(version[1])
      if (iOSVer < 9) {
        self.hack = true
      }
    }

    self.player = videojs(self.$refs.videoPlayer, {
      bigPlayButton: true,
      posterImage: true,
      autoplay: false,
      preload: 'auto',
      controls: true,
      controlBar: {
        children: [
          { name: 'playToggle' }, // 播放按钮
          { name: 'currentTimeDisplay' }, // 当前已播放时间
          { name: 'progressControl' }, // 播放进度条
          { name: 'durationDisplay' }, // 总时间
          // { // 倍数播放
          //   name: 'playbackRateMenuButton',
          //   'playbackRates': [0.5, 1, 1.5, 2, 2.5]
          // },
          {
            name: 'volumePanel', // 音量控制
            inline: false // 不使用水平方式
          },
          { name: 'FullscreenToggle' } // 全屏
        ]
      },
      sources: [
        {
          src: self.src.video,
          type: 'application/x-mpegURL'
        }, {
          src: self.src.source,
          type: 'video/mp4'
        }
      ],
      poster: self.src.coverImage,
      language: 'zh-CN'
    })

    self.player.on('play', () => {
      self.$emit('play')
    })

    self.player.on('error', (err) => {
      self.$sentry.captureException({
        title: 'error 播放出错',
        err
      })
      console.log('errr', err)
      self.hack = true
    })
  },
  methods: {
    hackPlayer() {
      this.updateSubjectItemStatus()
      window.open(`http://pub.mmcb.top/player.php?url=${this.src.video}`)
    },
    copyUrl() {
      console.log('copy..')
      let that = this
      this.$copyText(`http://pub.mmcb.top/player.php?url=${this.src.video}`).then(function (e) {
        console.log(e)
        that.$toast.success('复制成功')
      }, function (e) {
        console.log(e)
        that.$toast.fail('复制失败')
      })
    },
    updateSubjectItemStatus() {
      console.log('videoplayer updateSubjectItemStatus')
      this.$apollo.mutate({
        mutation: updateSubjectItemLearned,
        variables: {
          id: this.src.id
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        console.log('videoplayer update subject item success')
      }).catch(err => {
        console.error('videoplayer update subject item', err)
      })
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>
<style lang="scss">
  .video_box {
    position: relative;
    width: 100vw;
    height: 210px;
    background: black;
    .player-btn-hack{
      width: 220px;
      background-color: #ff8a01;
      text-align: center;
      border-radius: 25px;
      color: #fff;
      line-height: 2.5em;
      position: absolute;
      left: 22%;
      bottom: 10px;
    }
    .player-btn-hack-v2{
      bottom: 70px;
    }
    .video_play_button {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 54px;
      height: 54px;
      background: rgba(43,51,63,.7);
      border: 1px solid #fff;
      border-radius: 100%;
      z-index: 10248;
      &:after {
        content: '';
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
        border-left: 20px solid #fff;
        position: absolute;
        top: 15px;
        left: 20px;
      }
    }
    .video_poster {
      position: absolute;
      z-index: 10247;
      top: 0;
      height: 210px;
    }

    .video_content {
      width: 100%;
      height: 100%;
      background: #000000;
      object-fit: 'cover';
      // display: none;
    }
  }
  .video-js .vjs-big-play-button {
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 60px;
    height: 60px;
    border-radius: 30px;
    font-size: 36px;
    // width: 20%;
    // height: 20%;
  }
  .vjs-error .vjs-error-display:before {
    display: none;
  }
</style>
